export const CHANGE_ITEM = "mark/CHANGE_ITEM";
export const CHANGE_FACTOR_VALUE = "mark/CHANGE_FACTOR_VALUE";
export const CHANGE_SCORE_CARD = "mark/CHANGE_SCORE_CARD";
export const SUBMIT_SCORE = "mark/SUBMIT_SCORE";
export const AUTO_SAVE = "mark/AUTO_SAVE";
export const LOAD_AUTO_SAVE = "mark/LOAD_AUTO_SAVE";
export const SHOW_COPY_PROMPT = "mark/SHOW_COPY_PROMPT";
export const COPY_CONFIRM = "mark/COPY_CONFIRM";
export const COPY_CANCEL = "mark/COPY_CANCEL";
